import { Draft, PayloadAction } from '@reduxjs/toolkit';
import { IEventState }          from 'Redux/Slices/Event/EventSlice';
import { removeActionTypes }    from 'Utils/ReducerUtility';

export const sendBuyerMailRequest = (state: Draft<IEventState>, { type }: PayloadAction<{ id: string, subject: string, message: string, eventTicketId?: string }>) => {
  state.openRequests = [ ...state.openRequests, type ];
  state.failedRequests = removeActionTypes(state.failedRequests, type);
  state.updatedAt = Date.now();
};

export const sendBuyerMailSuccess = (state: Draft<IEventState>, { type }: PayloadAction<{
  recipientCount: number
}>) => {
  state.updatedAt = Date.now();
  state.openRequests = removeActionTypes(state.openRequests, type);
};

export const sendBuyerMailFailure = (state: Draft<IEventState>, { type }: PayloadAction<{ error: any }>) => {
  state.updatedAt = Date.now();
  state.failedRequests = [ ...state.failedRequests, type ];
  state.openRequests = removeActionTypes(state.openRequests, type);
};
